import React, {useState} from 'react'
import UploadFile from '../../components/commons/Upload'
import moment from 'moment';
import DatePicker from 'react-datepicker';
import { TrashIcon } from '../Icon';
import "react-datepicker/dist/react-datepicker.css";
import { Button,Label, UncontrolledPopover, PopoverHeader, PopoverBody } from 'reactstrap';
import UploadModal from '../commons/Upload/UploadModal';

interface Props {
    item: any;
    activeColumn: any;
    callback: any;
    handleUpload: any;
    handleRemoveUpload: any;
    rIdx: number;
    index: number;
    client_code: number;
}
const SwitchInput = ({
    activeColumn,
    item,
    callback,
    handleUpload,
    rIdx,
    index,
    client_code,
    handleRemoveUpload
}: Props) => {



    const [modal, toggleModal] = useState(false)

    const showUploadModal=()=>{
		toggleModal(!modal)
	}
    
    const validateInt = (e: any, rIdx: number, index: number) => {
        if (e.target.validity.valid) callback(e.target.value, rIdx, index)
        return false;
    }
    const testJSON = (text: any) => {
        if (typeof text !== "string") {
            return false;
        }
        try {
            JSON.parse(text);
            return true;
        }
        catch (error) {
            return false;
        }
    }

    const handleUploadLogic = (collection: any) => {

        if (collection) {
            if (testJSON(collection)) {

                let uploadData = JSON.parse(collection);
                let renderEl: any[] = [];

                if (uploadData && (uploadData instanceof Array)) {
                    return uploadData && uploadData.map((data: any, i: number) => {

                        renderEl.push(
                               
                            <p className="mt-3" key={i}>
                                <a href={data.column_value ? data.column_value : ''} target="_blank" className="uploaded_file_name">{data.name}
                                </a>
                                <a 
                                    className="pointer" 
                                    onClick={() => handleRemoveUpload(i, rIdx, index,)}
                                > 
                                    <TrashIcon />
                                </a>
                            </p>
                            
                        )
                        return <>
                            {
                                uploadData.length === 1 ?
                                    <>
                                      <div className="grid" key={index}>
                                      <div className="uploadcsv">
                                        <Label
                                            onClick={showUploadModal} 
                                            className="btn btn-outline-primary"
                                        ><i className="fas fa-cloud-upload-alt"> &nbsp;</i>
                                            Upload File
                                            </Label>
                                        </div>
                                    </div>

                                    <div className="grid" key={index}>
                                        <p className="mt-2" key={i}>
                                            <a href={data.column_value
                                                ? data.column_value
                                                : data.url
                                                    ? data.url
                                                    : ''} target="_blank" className="uploaded_file_name" >{data.name}</a>
                                            <a 
                                                className="pointer"
                                                 onClick={() => handleRemoveUpload(i, rIdx, index,)}
                                            > 
                                                <TrashIcon />
                                            </a>
                                        </p>
                                    </div>
                                  
                                    </>
                                    :
                                    null
                            }

                            {
                                (uploadData.length > 1) && i === (uploadData.length - 1) ?
                                    <>
                                        <div className="grid" key={index}>
                                            <div className="uploadcsv">
                                                <Label
                                                    onClick={showUploadModal} 
                                                    className="btn btn-outline-primary"
                                                ><i className="fas fa-cloud-upload-alt"> &nbsp;</i>
                                                    Upload File
                                                </Label>
                                            </div>
                                        </div>
                                        <div className="grid" key={index}>
                                            <button 
                                                id="PopoverLegacy" 
                                                type="button" 
                                                className="mt-2 btn btn-info"
                                            >
                                                {uploadData.length} Files uploaded
                                            </button>
                                            <UncontrolledPopover trigger="legacy" placement="bottom" target="PopoverLegacy">
                                                <PopoverHeader>Total uploaded file list</PopoverHeader>
                                                <PopoverBody>
                                                    {renderEl}
                                                </PopoverBody>
                                            </UncontrolledPopover>
                                        </div>
                                    
                                    </>
                                    : null
                            }
                        </>
                    })
                }
                return [null]
            } else {
                return <>
                 <div className="grid" key={index}>
                      {/* <UploadFile
                            uploadedUrl={handleUpload}
                            rIdx={rIdx}
                            index={index}
                            client_code={client_code}
                        /> */}
                   <div className="uploadcsv">
                        <Label
                            onClick={showUploadModal} 
                            className="btn btn-outline-primary"
                        ><i className="fas fa-cloud-upload-alt"> &nbsp;</i>
                            Upload File
                        </Label>
                    </div>
                 </div>

                <div className="grid" key={index}>
                    <a href={item.column_value} target="_blank" className="uploaded_file_name">{item.name} </a>
                    {
                        item.column_value && (item.data_type === 'image/png' || item.data_type === 'image/jpeg' || item.data_type === 'image/jpg') ? <img src={item.column_value} width='70' /> : <i className="far fa-file-alt"></i>
                    }
                </div>
                </>
            }
        }

        return (
            <div className="grid" key={index}>
                <div className="uploadcsv">
                <Label
                    onClick={showUploadModal} 
                    className="btn btn-outline-primary"
                ><i className="fas fa-cloud-upload-alt"> &nbsp;</i>
                    Upload File
                    </Label>
                </div>
        </div>)

    }

    // const renderUpload =()=>{
    //     if (item.column_name === 'upload') return handleUploadLogic(item.column_value);
    // }
    

    const renderGrid=()=>{
        switch (item.data_type) {
            case 'date': return (

                <div className="form-group">
                    <div className="float-label">
                        <label htmlFor="formData"
                            className={activeColumn ? "active" : ""}
                        >{item.name}</label>

                        <DatePicker
                            dateFormat="dd-MM-yyyy"
                            selected={item.column_value ? new Date(moment(`${ item.column_value }T00:00:00`, 'DD-MM-YYYY').format('YYYY-MM-DD[T]HH:mm:ss')) : null}
                            onChange={(date: any) => callback(moment(date).format('DD-MM-YYYY'), rIdx, index)}
                            fixedHeight
                            showMonthDropdown
                            showYearDropdown
                            className="form-control"
                        />
                    </div>
                </div>
            )
            case 'int': return (
                <div className="form-group">
                    <div className="float-label">
                        <label htmlFor="formData"
                            className={activeColumn ? "active" : ""}
                        >{item.name}</label>
                        <input
                            type="text"
                            pattern="[0-9]*"
                            className="form-control"
                            name={item.name}
                            value={item.column_value || ''}
                            placeholder={item.placeholder || ''}
                            onChange={(e) => validateInt(e, rIdx, index)}
                        />
                    </div>
                </div>
            )
            case 'double': return (
                <div className="form-group">
                    <div className="float-label">
                        <label htmlFor="formData"
                            className={activeColumn ? "active" : ""}
                        >{item.name}</label>
                        <input
                            type="number"
                            step="any"
                            className="form-control"
                            name={item.name}
                            value={item.column_value || ''}
                            placeholder={item.placeholder || ''}
                            onChange={(e) => callback(e.target.value, rIdx, index)}
                            onWheel={event => event.currentTarget.blur()}
                        />
                    </div>
                </div>
            )
            default: return <div className="form-group">
                <div className="float-label">
                    <label htmlFor="formData"
                        className={activeColumn ? "active" : ""}
                    >{item.name}</label>
                    <input
                        type={item.data_type}
                        className="form-control"
                        name={item.name}
                        value={item.column_value || ''}
                        placeholder={item.placeholder || ''}
                        onChange={(e) => callback(e.target.value, rIdx, index)}
                    />
                </div>
            </div>
        }
        
    }
    const renderHandleSwitch = () => {
        // if (item.column_name === 'upload') return;
        return(
            <div className="grid" key={index}>
                {renderGrid()}
            </div>
        )
    }


    return (
         <>
       
            {
                item.column_name !== 'upload' ? 
                 renderHandleSwitch(): null
               
            }
          
            {
                item.column_name === 'upload'? handleUploadLogic(item.column_value) : null
            }

        {modal ? <UploadFile
                    uploadedUrl={handleUpload}
                    rIdx={rIdx}
                    index={index}
                    client_code={client_code}
                    modal={modal}
                    toggleModal={showUploadModal}
                 /> : null}

    </>

    )
}

export default SwitchInput